import React from 'react';

import { useTranslation } from 'react-i18next';

import TooltipIcon from '../../../../pages/common/tooltip-icon';
import { Subsection } from '../../../subsection/subsection';
import { Icon } from '@weezevent/nacre';

import Style from './style/scheduled-event-publication.module.css';

// Coulnd't understand how to use the one from Nacre
function DateFormat({ date, locale = 'en-GB', options = { dateStyle: 'short', timeStyle: 'short' }, timezone }) {
    const _date = date instanceof Date ? date : new Date(date);

    let formatter = new Intl.DateTimeFormat(locale, { ...options, timeZone: timezone });
    return formatter.format(_date);
}

export function ScheduledEventPublication({ event }) {
    const { t, i18n } = useTranslation();

    if (!event.isPublicationScheduled()) {
        return null;
    }

    return (
        <Subsection>
            <div className={Style['title']}>
                <span>{t('ticket.menu.event.schedule_info.title')}</span>
                <TooltipIcon inline size="small" position={'top'} content={t('ticket.menu.event.schedule_info.title_tooltip')} triggerOnHover={true} />
            </div>
            <div>
                <span className={Style['info-text']}>
                    <Icon className={Style['inline-icon']} name="calendar" />
                    <DateFormat locale={i18n.language} date={event.publication_date || new Date()} timezone={event.timezone} />
                </span>
            </div>
        </Subsection>
    );
}
